import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "../api";
import { useLanguage } from "../i18n";

export default function VerifyEmail() {
  const { t } = useLanguage();
  const [params] = useSearchParams();
  const [state, setState] = useState({ phase: "loading", released: 0 });
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token") || "";
    (async () => {
      try {
        const { data } = await api.get("/auth/verify-email", { params: { token } });
        setState({ phase: "ok", released: data.released || 0 });
      } catch {
        setState({ phase: "error", released: 0 });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="verify-email-page">
      <div className="w-full max-w-md rounded-3xl bg-white border border-slate-200/80 shadow-sm p-8 text-center">
        {state.phase === "loading" && (
          <>
            <Loader2 className="w-8 h-8 animate-spin mx-auto text-[#FF6B35]" />
            <p className="mt-4 text-sm text-slate-500">{t("ver.loading")}</p>
          </>
        )}
        {state.phase === "ok" && (
          <>
            <CheckCircle2 className="w-10 h-10 mx-auto text-emerald-500" />
            <h1 className="mt-4 font-display font-bold text-2xl text-slate-900" data-testid="verify-ok-title">{t("ver.okT")}</h1>
            <p className="mt-2 text-sm text-slate-500">
              {state.released > 0 ? t("ver.okB").replace("{n}", state.released) : t("ver.okBnone")}
            </p>
          </>
        )}
        {state.phase === "error" && (
          <>
            <XCircle className="w-10 h-10 mx-auto text-red-400" />
            <h1 className="mt-4 font-display font-bold text-2xl text-slate-900" data-testid="verify-err-title">{t("ver.errT")}</h1>
            <p className="mt-2 text-sm text-slate-500">{t("ver.errB")}</p>
          </>
        )}
        <Link to="/account" data-testid="verify-goto-account"
          className="mt-6 inline-block rounded-full bg-[#FF6B35] text-white px-6 py-3 font-mono-t text-[10px] font-bold uppercase tracking-[0.2em] hover:bg-[#E8551F] transition-colors">
          {t("ver.goto")}
        </Link>
      </div>
    </div>
  );
}
